// src/main.jsx DOĞRU HALİ
import React from 'react'
import ReactDOM from 'react-dom/client'
import { MantineProvider } from '@mantine/core'
import { BrowserRouter } from 'react-router-dom' // <-- BURADA KALSIN
import App from './App.js'
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css'; // <--- BU SATIRI EKLEMEN GEREKİYOR! (Sorunu bu çözecek)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MantineProvider>
      <BrowserRouter> {/* <-- Router burada başlar */}
        <App />
      </BrowserRouter>
    </MantineProvider>
  </React.StrictMode>,
)